/** Stable synthetic user id for Bruno (not a Cognito account). */
export const BRUNO_BOT_USER_ID = '00000000-0000-4000-8000-000000000001'

export const BRUNO_DISPLAY_NAME = 'Bruno'

export const BRUNO_AVATAR_URL =
  'https://api.dicebear.com/7.x/bottts/png?seed=bruno'

export function isBrunoUserId(userId: string | null | undefined): boolean {
  return userId === BRUNO_BOT_USER_ID
}

export function isBrunoConversation(c: {
  type?: string
  conversationType?: string
  participantIds?: string[]
}): boolean {
  const type = c.type ?? c.conversationType
  const participantIds = c.participantIds ?? []
  return (
    type === 'DIRECT' &&
    participantIds.length === 2 &&
    participantIds.includes(BRUNO_BOT_USER_ID)
  )
}

export function isPersonalBrunoConversation(
  c: { participantIds?: string[] },
  meId: string,
): boolean {
  return isBrunoConversation(c) && (c.participantIds ?? []).includes(meId)
}

export function partitionMentions(mentionIds: string[] | undefined): {
  brunoMentioned: boolean
  humanMentions: string[]
} {
  const ids = mentionIds ?? []
  const brunoMentioned = ids.some(isBrunoUserId)
  const humanMentions = ids.filter((id) => !isBrunoUserId(id))
  return { brunoMentioned, humanMentions }
}
